import styled from '@emotion/styled'

export const Container = styled('div')`
  padding-top: 27px;
`

export const Label = styled('div')`
  color: #666666;
`

export const Counter = styled('div')`
  font-weight: bold;
`
